import { wcstInstruction } from "@constants/instructionConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  TestUIConfiguration,
} from "types/testTypes";
import {
  CATEGORY_VERSION_MAP,
  FEATURE_VERSION_MAP,
  TEST_TYPE_VERSION_MAP,
} from "../versionConstants";
import { AVAILABLE_EYE_OPTIONS_BINOCULAR } from "../configurationHelperConstants";
import { virtualAssistanceWCSTConfig } from "@constants/virtualAssistanceConstants";
import { VIRTUAL_ASSISTANT_LANGUAGE_LIST } from "@constants/languageConstants";

export const availableWCSTTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    choices: [
      {
        value: TestType.WCST,
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.WCST],
      },
    ],
    isMandatory: true,
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.WisconsinCardSorting],
  },
  eyeConfigurationOptions: {
    ...AVAILABLE_EYE_OPTIONS_BINOCULAR,
  },
  testSpeedOptions: null,
  languageOptions: null,
  virtualAssistantOptions: {
    configurationFieldName: "virtualAssistanceConfig",
    validSinceVersion: FEATURE_VERSION_MAP["minVirtualAssistant"],
    choices: VIRTUAL_ASSISTANT_LANGUAGE_LIST,
  },
};

export const wcstTestConfiguration: TestConfiguration = {
  name: TestCategory.WisconsinCardSorting,
  testType: TestType.WCST,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: false,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: false,
    isBackToBackEyeTest: false,
  },
  testSpeed: null,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceWCSTConfig,
  isPressToStartEnabled: true,
  extraData: {
    trialCount: 30,
    ruleChangeWindow: 10,
  },
};

export const wcstUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: wcstInstruction,
};
